import { useEffect, useMemo } from 'react';

import { debounce } from 'lodash';

export const useDebouncedFunction = <F extends (...args: any[]) => void>(func: F, delay: number) => {
    const debouncedFunction = useMemo(
        () =>
            debounce((...args: Parameters<F>) => {
                func(...args);
            }, delay),
        [func, delay],
    );

    useEffect(() => {
        return () => {
            debouncedFunction.cancel();
        };
    }, [debouncedFunction]);

    return debouncedFunction as unknown as F;
};
